import Model from './Model'

export default class GetStatus extends Model
{
    resource()
    {
        return 'getStatus'
    }
}
